// Theme mode controller. Sets `data-theme` on <html> so the CSS token layer
// (tokens.css for Paper, styles.css for the Hub aliases) flips between light and
// dark. Recepthor's identity is the light "Paper of Record" — the prototype is
// data-mode="light" — so light is the default; only an explicit user choice (the
// topbar toggle) switches to dark. The OS preference is NOT followed (it was
// forcing navy content over a brand that is cream paper).
//
// Built on the shared createPreference primitive. The named exports below are
// the stable public surface (consumed by Topbar, Configuracion, src/index.jsx
// and the lib barrel).
import { createPreference } from './preference';

const pref = createPreference('theme', {
  fallback: 'light',
  valid: ['light', 'dark'],
  applyAttr: 'theme',
});

export const resolveThemeMode = pref.resolve;
export const initThemeMode = pref.init;

export function toggleThemeMode() {
  return pref.set(resolveThemeMode() === 'dark' ? 'light' : 'dark');
}
